<template>
  <PartnerListWidget :href="ctaLink" @click="onLinkClick">
    <template #icon>
      <HgIcon icon="SecurityDeposit" size="large" theme="secondary" />
    </template>
    <template #content>
      <span v-if="isCommercialListing(listing)">
        {{ t('integrations.swissCautionRentalGuarantee.commercial.message') }}
        <span :class="$style.cta">
          {{ t(`integrations.swissCautionRentalGuarantee.commercial.action`) }}
        </span>
      </span>
      <span v-else>
        {{ t('integrations.swissCautionRentalGuarantee.residential.message') }}
        <span :class="$style.cta">
          {{ t(`integrations.swissCautionRentalGuarantee.residential.action`) }}
        </span>
      </span>
    </template>
  </PartnerListWidget>
</template>

<script lang="ts" setup>
import { HgIcon } from '@smg-real-estate/domus';
import { Listing } from '@smg-real-estate/hg-rets-schema';

import PartnerListWidget from '@/components/PartnerIntegrations/PartnerListWidget/PartnerListWidget.vue';
import { InteractionGoal } from '@/helpers/GTM/GTMParameters';

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { getSwissCautionListingType, isCommercialListing } from '../functions/helpers';

const { t } = useI18n();

defineOptions({
  name: 'SwissCautionRentalGuarantee',
});

interface Props {
  listing: Listing;
}
const props = defineProps<Props>();

const emit = defineEmits<{
  trackPartnerLink: [link: string, eventLabel: InteractionGoal];
}>();

const ctaLink = computed((): string => {
  return t(`integrations.swissCautionRentalGuarantee.${listingType.value}.href`);
});
const listingType = computed((): string => {
  return getSwissCautionListingType(props.listing);
});

const onLinkClick = () => {
  emit('trackPartnerLink', ctaLink.value, InteractionGoal.RENTAL_PROVISIONAL_CERT);
};
</script>
<style lang="scss" module>
@import '@/assets/variables';

.cta {
  color: var(--base-color-link);

  @include font-bold;
}
</style>
